import getCompanyId from '@/composables/get-companyid';

export const oidcSettings = {
	authority: process.env.VUE_APP_AUTH_SERVER,
	clientId: 'vueuser',
	redirectUri: process.env.VUE_APP_URL + '/system/oidc-callback',
	responseType: 'id_token token',
	scope:
		'openid vue.app Vue.Api Email SupportTech AspNetCompaniesId Role FirstName LastName EmployeeRolePermission EmployeeRoleFeature CurrentEmployeeCompanyId EmployeeCompanyIds PageVersions EmployeeId EmployeeImage CurrentCompanyName CompanyOEMs PositionNames DealershipGroupNumber CompanyConfigurations.QuickSearchDefault EnvironmentName EnvironmentSubdomain EnabledFeatureSwitches',
	post_logout_redirect_uri: process.env.VUE_APP_URL,
	extraQueryParams: {
		companyId: getCompanyId()
	},
	silentRedirectUri: process.env.VUE_APP_URL + '/system/oidc-silent-renew',
	automaticSilentRenew: true, // If true oidc-client will try to renew your token when it is about to expire
	dispatchEventsOnWindow: true,
	test: process.env.VUE_APP_BASE_ROUTE
};
